import ConfirmPhone from './confirm-phone-container';
import ConfirmPhoneView from './confirm-phone-view';

export default ConfirmPhone;
export { ConfirmPhoneView };
